// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Footer_footerWrapper__iJhWd","footerLogo":"Footer_footerLogo__4bv8F","footerText":"Footer_footerText__+DTnG"};